<template>
    <span>
        <b-button
            class="align-baseline mr-1"
            title="Restore"
            variant="default"
            :disabled="!templateCanRestore"
            @click="handleRestoreTemplate"
        >
            <font-awesome-icon :icon="['fas', 'gears']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline mr-1" title="Clone" variant="default" @click="handleCloneTemplate">
            <font-awesome-icon :icon="['fas', 'copy']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline mr-1" title="Edit" variant="default" :to="templateEditLink">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            :disabled="!templateCanDelete"
            class="align-baseline"
            title="Delete"
            variant="default"
            v-b-modal="deleteModalID"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal :id="deleteModalID" title="Delete Template" @shown="onModalShown" @ok="handleDeleteTemplate"
            >Are you sure you want to delete template "{{ templateName }}"?</modal
        >
    </span>
</template>

<script>
import Modal from '../../generic/modal/modal.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        Modal,
    },
    data() {
        return {
            templateID: 0,
            templateName: '',
            templateEditLink: '',
            templateHidden: false,
            templateCanDelete: false,
            deleteModalID: '',
        };
    },
    created() {
        this.templateID = this.params.data.id;
        this.templateName = this.params.data.report_name;
        this.templateHidden = this.params.data.hidden;
        this.templateCanDelete = this.params.data.can_delete;
        this.templateCanRestore = this.params.data.can_restore;
        this.templateEditLink = `/app/document/${this.params.data.id}/edit/`;
        this.deleteModalID = `modal-delete-template-${this.templateID}`;
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handleCloneTemplate() {
            this.params.clone && this.params.clone(this.params.data);
        },
        handleDeleteTemplate() {
            this.params.delete && this.params.delete(this.params.data);
        },
        handleRestoreTemplate() {
            this.params.restore && this.params.restore(this.params.data);
        },
    },
};
</script>
